export const SET_FAMILY_SEARCH_TOKEN = 'SET_FAMILY_SEARCH_TOKEN';
export const SET_POSSIBLE_ROOTS = 'SET_POSSIBLE_ROOTS';


// WEBPACK FOOTER //
// ./src/core/family-search/action-types.js